import type { ShareAuthCheckData, AuthPageParams } from '../types';

export interface AuthService {
  shareAccessCheck(data?: ShareAuthCheckData): Promise<boolean>;
  setPageParams(params: AuthPageParams): void;
  get pageParams(): AuthPageParams;
}

export const AuthService = Symbol('AuthService');
